if(!window.GS) GS={};
if(!window.GS.Filters) GS.Filters={};

(function(){
    var f = new Class({
        Extends: GS.Filters.BaseFilter,
        class_name:'GS.Filters.Gradient',
        options:{
            'debug':0,
            'dx': 0,
            'dy':0,
            'color': '#000',
            'blur':10,
            'inType':'SourceAlpha'
        },
        filter: {
            'id':0,
            'container':null,
            'blur':null,
            'offset':null,
            'color':null
        }

    });

    f.prototype.createFilter=function(){
        var f;

        f = new Element('linearGradient', {'id': this.filter.id});
        if(this.options.type === 'vertical'){
            f.setAttribute('x1','0%');
            f.setAttribute('y1','0%');
            f.setAttribute('x2','0%');
            f.setAttribute('y2','100%');
        }
        this.filter.container=f;
        this.addGradientsSteps();
        this.defs.adopt(f);
    };

    /**
     * Apply/Attach gradient to element
     * @param {SVG Element} ele
     * @returns {void}
     */
    f.prototype.applyTo=function(ele){
        (ele.node || ele).setAttribute('fill',"url('#"+this.filter.id+"')");
    };

    f.prototype.addGradientsSteps = function (){
        //console.debug(this.options);
        var steps = [];
        this.options.steps.map(function(step){
            steps.push(new Element('stop', {'offset' : step.offset, 'stop-color': step['color'] || 'transparent', 'stop-opacity': step['opacity'] || 0}))
        });

        this.filter.container.adopt(steps);
    };

    this.Gradient = f;
}.call(GS.Filters));
